import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/diveAN/step3';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Rectificatif } from '../../models/Rectificatif';

@Component({
	selector: 'app-step3',
	templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {
	private LOG: LogService = new LogService(Step3Component);

	@Input() rectificatif: Rectificatif;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() uid = '';

	public step3 = new Step3();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService
	) { }

	ngOnInit(): void {
	}

	public getUid() {
		return this.uid;
	}
}
